import React from 'react';
import { Fade } from 'react-awesome-reveal';
import PageHeader from '../components/PageHeader';
import FactItem from '../components/FactItem';
import ServiceSection from '../components/ServiceSection';
import IntegratedAreas from '../components/IntegratedAreas';

const Service = () => {
  const breadcrumb = [
    { label: 'Home', href: '/' },
    { label: 'Pages', href: '#' },
    { label: 'Services', href: '/service', active: true }
  ];

  return (
    <>
      <PageHeader title="Services" breadcrumb={breadcrumb} />
      <Fade triggerOnce>
        <div className="container-xxl py-6">
          <div className="container">
            <div className="row g-4">
      <FactItem 
        icon="fa fa-building" 
        label="Commercial Projects" 
        value={272} 
        delay={100} 
        suffix="+"
      />
      <FactItem 
        icon="fa fa-home" 
        label="Residential Designs" 
        value={153} 
        delay={300} 
        suffix="+"
      />
      <FactItem 
        icon="fa fa-clock" 
        label="On-time Delivery" 
        value={100} 
        delay={500} 
        suffix="%"
      />
      <FactItem 
        icon="fa fa-globe" 
        label="Countries Served" 
        value={4} 
        delay={700} 
        suffix="+"
      />
    </div>
          </div>
        </div>
      </Fade>
      <ServiceSection />
      <IntegratedAreas/>
    </>
  );
};

export default Service;






